import React, { ChangeEvent } from 'react'

import { TextField } from '@toptal/picasso'

export type ChangeEventType = ChangeEvent<
  HTMLTextAreaElement | HTMLInputElement | HTMLSelectElement
>

interface IProps {
  value: string
  name?: string
  label?: string
  rows?: number
  style?: object
  onChange(event: ChangeEventType): void
}

const TextArea: React.FunctionComponent<IProps> = ({
  rows = 10,
  label,
  name,
  value,
  onChange,
  ...props
}) => {
  return (
    <TextField
      fullWidth={true}
      label={label}
      multiline={true}
      name={name}
      onChange={onChange}
      rows={rows}
      value={value}
      {...props}
    />
  )
}

export default TextArea
